import axios from 'common/utils/axios';
import { QuickLink } from './types';
import { QuickLinkTypeEnum } from './quick-link-type.enum';

const api = axios('quick-links');

export const getQuickLinksApi = (id: string, quickLinkType: QuickLinkTypeEnum) => {
  return api.get('', { params: { id, quickLinkType } });
};

export const createQuickLinkApi = ({ ...data }: any) => {
  return api.post('', data);
};

export const updateQuickLinkApi = ({ id, ...data }: QuickLink) => {
  return api.put(id, data);
};

export const deleteQuickLinkApi = (id: string) => {
  return api.delete(id);
};

export const searchQuickLinksApi = (params: any) => {
  return api.get('search', { params });
};
